export enum ExternalIdTypeDto {
  ASSIGNMENT_ID = 'assignmentId',
  CATALOG_ITEM_ID = 'catalogItemId',
  // COURSE_SECTION_ID = 'courseSectionId', // Deprecated but still exists in database
  TAXONOMY_NODE_ID = 'taxonomyNodeId',
}

export enum ActiveSyllabusItemTypeDto {
  ADAPTIVE_LESSON = 'ADAPTIVE_LESSON',
  ADAPTIVE_QUIZ = 'ADAPTIVE_QUIZ',
  EBOOK_READING = 'EBOOK_READING',
  EVOLVE_INSTRUCTOR_RESOURCE = 'EVOLVE_INSTRUCTOR_RESOURCE',
  EVOLVE_STUDENT_RESOURCE = 'EVOLVE_STUDENT_RESOURCE',
  FOLDER = 'FOLDER',
  SHERPATH_LESSON = 'SHERPATH_LESSON',
  SHERPATH_SIMULATIONS = 'SHERPATH_SIMULATIONS',
  SHERPATH_SKILL = 'SHERPATH_SKILL',
  SIMCHART_CASE_STUDY = 'SIMCHART_CASE_STUDY',
  SIMCHART_CHART = 'SIMCHART_CHART',
  SHADOW_HEALTH_ASSIGNMENT = 'SHADOW_HEALTH_ASSIGNMENT',
  ASSESSMENT_BUILDER_ASSIGNMENT = 'ASSESSMENT_BUILDER_ASSIGNMENT',
  // Front-end only: never persisted or returned by the syllabus service. MedEd MCQ items are stored as ADAPTIVE_QUIZ and
  // shown as MCQ via getSyllabusItemDisplayType; this value is only the config-map, strategy-registry and display key.
  MCQ_QUIZ = 'MCQ_QUIZ',
  SHERPATH_POWERPOINT = 'SHERPATH_POWERPOINT',
  SHERPATH_GROUP_ACTIVITY = 'SHERPATH_GROUP_ACTIVITY',
  SHERPATH_CASE_STUDY = 'SHERPATH_CASE_STUDY',
  CUSTOM_LINK = 'CUSTOM_LINK',
  OSMOSIS_VIDEO = 'OSMOSIS_VIDEO',
  INTERACTIVE_REVIEW = 'INTERACTIVE_REVIEW',
  SIMULATION_INSTRUCTOR_RESOURCE = 'SIMULATION_INSTRUCTOR_RESOURCE',
  SIMULATION_STUDENT_RESOURCE = 'SIMULATION_STUDENT_RESOURCE',
  READING_ASSIGNMENT = 'READING_ASSIGNMENT',
  LAB_SIMULATION_IMPLEMENTATION_MODULE = 'LAB_SIMULATION_IMPLEMENTATION_MODULE',
  VR_SIMULATION_IMPLEMENTATION_MODULE = 'VR_SIMULATION_IMPLEMENTATION_MODULE',
  VR_SIMULATION = 'VR_SIMULATION',
  SLS_SIMCHART_SIMULATION_EHR = 'SLS_SIMCHART_SIMULATION_EHR',
  PATIENT_REPORT = 'PATIENT_REPORT',
  PRE_SIMULATION_QUIZ = 'PRE_SIMULATION_QUIZ',
  POST_SIMULATION_QUIZ = 'POST_SIMULATION_QUIZ',
  SCMO_NG = 'SCMO_NG',
  PRE_SIMULATION_EXERCISE = 'PRE_SIMULATION_EXERCISE',
  POST_SIMULATION_EXERCISE = 'POST_SIMULATION_EXERCISE',
  JOURNAL_EXERCISE = 'JOURNAL_EXERCISE',
  SBAR_EXERCISE = 'SBAR_EXERCISE',
  HESI_ASSESS = 'HESI_ASSESS',
  VERBAL_REPORT_TEMPLATE = 'VERBAL_REPORT_TEMPLATE',
  OBSERVER_EVALUATION_RUBRIC = 'OBSERVER_EVALUATION_RUBRIC',
  PERFORMANCE_CHECKLIST = 'PERFORMANCE_CHECKLIST',
}

export enum ActiveStudentSyllabusItemTypeDto {
  ADAPTIVE_LESSON = 'ADAPTIVE_LESSON',
  ADAPTIVE_QUIZ = 'ADAPTIVE_QUIZ',
  // Front-end only filter option (never persisted); MedEd MCQ items are stored as ADAPTIVE_QUIZ, see getSyllabusItemDisplayType.
  MCQ_QUIZ = 'MCQ_QUIZ',
  SHERPATH_LESSON = 'SHERPATH_LESSON',
  SHERPATH_SIMULATIONS = 'SHERPATH_SIMULATIONS',
  SHERPATH_SKILL = 'SHERPATH_SKILL',
  SIMCHART_CASE_STUDY = 'SIMCHART_CASE_STUDY',
  SIMCHART_CHART = 'SIMCHART_CHART',
  SHADOW_HEALTH_ASSIGNMENT = 'SHADOW_HEALTH_ASSIGNMENT',
  ASSESSMENT_BUILDER_ASSIGNMENT = 'ASSESSMENT_BUILDER_ASSIGNMENT',
  OSMOSIS_VIDEO = 'OSMOSIS_VIDEO',
  INTERACTIVE_REVIEW = 'INTERACTIVE_REVIEW',
  LAB_SIMULATION_IMPLEMENTATION_MODULE = 'LAB_SIMULATION_IMPLEMENTATION_MODULE',
  VR_SIMULATION_IMPLEMENTATION_MODULE = 'VR_SIMULATION_IMPLEMENTATION_MODULE',
  VR_SIMULATION = 'VR_SIMULATION',
  SLS_SIMCHART_SIMULATION_EHR = 'SLS_SIMCHART_SIMULATION_EHR',
  PRE_SIMULATION_QUIZ = 'PRE_SIMULATION_QUIZ',
  POST_SIMULATION_QUIZ = 'POST_SIMULATION_QUIZ',
  HESI_ASSESS = 'HESI_ASSESS',
  PRE_SIMULATION_EXERCISE = 'PRE_SIMULATION_EXERCISE',
  POST_SIMULATION_EXERCISE = 'POST_SIMULATION_EXERCISE',
  JOURNAL_EXERCISE = 'JOURNAL_EXERCISE',
  SBAR_EXERCISE = 'SBAR_EXERCISE'
}

// TODO: These need to be removed from services
export enum DeprecatedSyllabusItemTypeDto {
  EVOLVE_RESOURCE = 'EVOLVE_RESOURCE',
  SIMCHART = 'SIMCHART',
}

export type SyllabusItemTypeDto = ActiveSyllabusItemTypeDto | DeprecatedSyllabusItemTypeDto;
